import { IQuestion } from './Question'

export interface IResponse<Type = any> {
  question: IQuestion
  // These are the user selected answers to questions.
  // E.g "During sex I like" => [{ value: "Cowgirl" }, { value: "Butt Play" }]
  // E.g "How fast" => [{ value: 10, label: "light touch" }]
  answers: IResponseAnswer<Type>[]
  answered: boolean
  filtered: boolean
}

export interface IResponseAnswer<Type = any> {
  value: Type extends 'single' | 'multi' ? string : number
  label?: string
}

export const singleOrMultiAnswers = (
  answers: IResponse['answers']
): IResponse<'single'>['answers'] =>
  answers.filter(a => typeof a.value === 'string')
